import { podeMedirAudiencia } from './consentimento';

/**
 * Mede cliques nos botões marcados com `data-clique="nome"` da página pública.
 *
 * Um ouvinte só no documento, em vez de um `onClick` por botão: marcar um alvo
 * novo é acrescentar o atributo, sem mexer em lógica — e esquecer de medir um
 * botão não quebra nada.
 *
 * Mesmas regras da visita: só com consentimento de medição, sem identificar
 * ninguém, `keepalive` para sobreviver à navegação que o próprio clique dispara,
 * e falha em silêncio.
 *
 * Devolve a função que remove o ouvinte (para o `useEffect`).
 */
export function medirCliques(): () => void {
  const aoClicar = (e: MouseEvent) => {
    if (!podeMedirAudiencia()) return;
    const el = (e.target as Element | null)?.closest?.('[data-clique]');
    const alvo = el?.getAttribute('data-clique');
    if (!alvo) return;
    void fetch('/api/metricas/clique', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({ caminho: window.location.pathname, alvo }),
    }).catch(() => undefined);
  };
  // Captura: o Link do router navega no clique, e a página some antes de um
  // ouvinte em fase de bolha ter garantia de rodar.
  document.addEventListener('click', aoClicar, true);
  return () => document.removeEventListener('click', aoClicar, true);
}
